import { ConversationMessageContent } from '@modules/conversation-message/ConversationMessageContent';
import { styled } from '@mui/material';

export const StyledConversationMessageContent = styled(
  ConversationMessageContent,
)(({ theme }) => ({
  fontSize: theme.typography.caption.fontSize,
}));
